export default __webpack_public_path__ + "static/footer-background-48d8e399a9b9b30a289fe2e25bf57474.png";